var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bar"},[_c('span',{staticClass:"bar-fill",style:({ width: _vm.width, background: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }